import type { ComponentType } from 'react'
import { Badge } from '../ui/badge'

// Flush page-level tab strip button (Dashboard, Content Hub, Screens, Users,
// Asset tabs, etc.) — SINGLE shared source, do not re-copy per-file. Active
// state is a soft filled pill (background + text colour), not just an
// underline, so it reads clearly at a glance. The label hides below `sm`
// (icon-only) since every consumer always passes an icon — `aria-label`
// keeps it accessible when the text is hidden.
export function TabButton({
  active, onClick, icon: Icon, label, badge,
}: {
  active: boolean
  onClick: () => void
  icon: ComponentType<{ className?: string }>
  label: string
  badge?: number
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ${
        active
          ? 'bg-primary/10 text-primary'
          : 'text-muted-foreground hover:text-foreground hover:bg-muted'
      }`}
    >
      <Icon className="w-4 h-4 shrink-0" />
      <span className="hidden sm:inline">{label}</span>
      {badge != null && badge > 0 && (
        <Badge
          variant="secondary"
          className={`h-4 text-[10px] px-1 ${active ? 'bg-primary/15 text-primary' : ''}`}
        >
          {badge}
        </Badge>
      )}
    </button>
  )
}
